import { FundingPolicyType } from '@shared';

export const sharedQuestions: Record<string, PolicyFormQuestion> = {
  /* Section 1 - Proposed Insured */
  proposedInsuredName: {
    id: 'proposed-insured-name',
    questionRef: 'proposedInsuredName',
    title: 'Name (First, MI, Last)',
    type: 'text',
    required: true,
  },
  proposedInsuredSex: {
    id: 'proposed-insured-sex',
    questionRef: 'proposedInsuredSex',
    title: 'Sex',
    type: 'radio',
    required: true,
    options: [
      { id: 'male', value: 'M' },
      { id: 'female', value: 'F' },
    ],
  },
  proposedInsuredDob: {
    id: 'proposed-insured-dob',
    questionRef: 'proposedInsuredDob',
    title: 'Date of Birth',
    type: 'date',
    required: true,
  },
  proposedInsuredStateOfBirth: {
    id: 'proposed-insured-state-of-birth',
    questionRef: 'proposedInsuredStateOfBirth',
    title: 'State of Birth (If outside U.S., provide country)',
    type: 'text',
    required: true,
  },
  proposedInsuredSsn: {
    id: 'proposed-insured-ssn',
    questionRef: 'proposedInsuredSsn',
    title: 'SSN/Tax ID #',
    type: 'text',
    required: true,
    validationType: 'ssn',
  },
  proposedInsuredEmail: {
    id: 'proposed-insured-email',
    questionRef: 'proposedInsuredEmail',
    title: 'E-mail Address',
    type: 'text',
    required: true,
    validationType: 'email',
  },
  proposedInsuredAddress: {
    id: 'proposed-insured-address',
    questionRef: 'proposedInsuredAddress',
    title: 'Address (street/city/state/ZIP)',
    type: 'text',
    required: true,
    validationType: 'address',
  },
  proposedInsuredPhone: {
    id: 'proposed-insured-phone',
    questionRef: 'proposedInsuredPhone',
    title: 'Phone #',
    type: 'text',
    required: true,
    validationType: 'phone',
  },
  proposedInsuredMaritalStatus: {
    id: 'proposed-insured-marital-status',
    questionRef: 'proposedInsuredMaritalStatus',
    title: 'Marital Status',
    type: 'radio',
    required: true,
    format: 'vertical',
    options: [
      { id: 'married', value: 'Married' },
      { id: 'single', value: 'Single' },
      { id: 'civil-union', value: 'Civil Union' },
      { id: 'domestic-partner', value: 'Domestic Partner' },
      { id: 'other', value: 'Other' },
    ],
  },
  proposedInsuredMaritalOther: {
    id: 'proposed-insured-marital-other',
    questionRef: 'proposedInsuredMaritalOther',
    title: 'Other:',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredMaritalStatus',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'proposedInsuredMaritalStatus',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  proposedInsuredCitizenship: {
    id: 'proposed-insured-citizenship',
    questionRef: 'proposedInsuredCitizenship',
    title: 'Citizenship',
    type: 'radio',
    required: true,
    options: [
      { id: 'us', value: 'U.S.' },
      { id: 'green-card', value: 'Green Card Holder' },
      { id: 'visa', value: 'Visa' },
      { id: 'other', value: 'Other' },
    ],
  },
  proposedInsuredGreenCardIssueDate: {
    id: 'proposed-insured-green-card-issue-date',
    questionRef: 'proposedInsuredGreenCardIssueDate',
    title: 'Green Card Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  proposedInsuredGreenCardExpirationDate: {
    id: 'proposed-insured-green-card-expiration-date',
    questionRef: 'proposedInsuredGreenCardExpirationDate',
    title: 'Green Card Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  proposedInsuredVisaType: {
    id: 'proposed-insured-visa-type',
    questionRef: 'proposedInsuredVisaType',
    title: 'Visa Type',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  proposedInsuredVisaIssueDate: {
    id: 'proposed-insured-visa-issue-date',
    questionRef: 'proposedInsuredVisaIssueDate',
    title: 'Visa Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  proposedInsuredVisaExpirationDate: {
    id: 'proposed-insured-visa-expiration-date',
    questionRef: 'proposedInsuredVisaExpirationDate',
    title: 'Visa Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  proposedInsuredOther: {
    id: 'proposed-insured-other',
    questionRef: 'proposedInsuredOther',
    title: 'Other:',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'proposedInsuredCitizenship',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  proposedInsuredUsResidenceMonths: {
    id: 'proposed-insured-us-residence-months',
    questionRef: 'proposedInsuredUsResidenceMonths',
    title: 'How long have you lived in the U.S.? (Months)',
    type: 'text',
    required: true,
    validationType: 'numberOnly',
  },
  proposedInsuredUsResidenceYears: {
    id: 'proposed-insured-us-residence-years',
    questionRef: 'proposedInsuredUsResidenceYears',
    title: 'How long have you lived in the U.S.? (Years)',
    type: 'text',
    required: true,
    validationType: 'numberOnly',
  },
  proposedInsuredUnderstandEnglish: {
    id: 'proposed-insured-understand-english',
    questionRef: 'proposedInsuredUnderstandEnglish',
    title: 'Do you read and understand English?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  proposedInsuredPrimaryLanguage: {
    id: 'proposed-insured-primary-language',
    questionRef: 'proposedInsuredPrimaryLanguage',
    title: 'If no, provide primary spoken language',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'proposedInsuredUnderstandEnglish',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'proposedInsuredUnderstandEnglish',
        operator: 'equals',
        value: 'no',
      },
    },
  },
  proposedInsuredFormerName: {
    id: 'proposed-insured-former-name',
    questionRef: 'proposedInsuredFormerName',
    title: 'Former Name',
    type: 'text',
    required: false,
  },
  proposedInsuredDriversLicense: {
    id: 'proposed-insured-drivers-license',
    questionRef: 'proposedInsuredDriversLicense',
    title: "Driver’s License #/State of Issue",
    type: 'text',
    required: true,
  },
  proposedInsuredStateOfIssue: {
    id: 'proposed-insured-state-of-issue',
    questionRef: 'proposedInsuredStateOfIssue',
    title: 'State of Issue',
    type: 'text',
    required: true,
  },
  proposedInsuredOccupation: {
    id: 'proposed-insured-occupation',
    questionRef: 'proposedInsuredOccupation',
    title: 'Occupation',
    type: 'text',
    required: true,
  },
  proposedInsuredEmployer: {
    id: 'proposed-insured-employer',
    questionRef: 'proposedInsuredEmployer',
    title: 'Employer',
    type: 'text',
    required: true,
  },
  proposedInsuredAnnualIncome: {
    id: 'proposed-insured-annual-income',
    questionRef: 'proposedInsuredAnnualIncome',
    title: 'Annual Income',
    type: 'text',
    required: true,
    validationType: 'currency',
  },
  proposedInsuredNetWorth: {
    id: 'proposed-insured-net-worth',
    questionRef: 'proposedInsuredNetWorth',
    title: 'Net Worth',
    type: 'text',
    required: true,
    validationType: 'currency',
  },

  /* Section 2 - Proposed Additional Insured (for CareMatters Together only) */
  additionalInsuredName: {
    id: 'additional-insured-name',
    questionRef: 'additionalInsuredName',
    title: 'Name (First, MI, Last)',
    type: 'text',
    required: true,
  },
  additionalInsuredSex: {
    id: 'additional-insured-sex',
    questionRef: 'additionalInsuredSex',
    title: 'Sex',
    type: 'radio',
    required: true,
    options: [
      { id: 'male', value: 'M' },
      { id: 'female', value: 'F' },
    ],
  },
  additionalInsuredDob: {
    id: 'additional-insured-dob',
    questionRef: 'additionalInsuredDob',
    title: 'Date of Birth',
    type: 'date',
    required: true,
  },
  additionalInsuredStateOfBirth: {
    id: 'additional-insured-state-of-birth',
    questionRef: 'additionalInsuredStateOfBirth',
    title: 'State of Birth (If outside U.S., provide country)',
    type: 'text',
    required: true,
  },
  additionalInsuredSsn: {
    id: 'additional-insured-ssn',
    questionRef: 'additionalInsuredSsn',
    title: 'SSN/Tax ID #',
    type: 'text',
    required: true,
    validationType: 'ssn',
  },
  additionalInsuredEmail: {
    id: 'additional-insured-email',
    questionRef: 'additionalInsuredEmail',
    title: 'E-mail Address',
    type: 'text',
    required: true,
    validationType: 'email',
  },
  additionalInsuredSameAddress: {
    id: 'additional-insured-same-address',
    questionRef: 'additionalInsuredSameAddress',
    title: '',
    type: 'multiselect',
    required: false,
    options: [{ id: 'yes', value: 'Check box if address is same as Proposed Primary Insured' }],
  },
  additionalInsuredAddress: {
    id: 'additional-insured-address',
    questionRef: 'additionalInsuredAddress',
    title: 'Address (street/city/state/ZIP)',
    type: 'text',
    required: false,
    validationType: 'address',
    conditional: {
      visible: {
        field: 'additionalInsuredSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'additionalInsuredSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  additionalInsuredPhone: {
    id: 'additional-insured-phone',
    questionRef: 'additionalInsuredPhone',
    title: 'Phone #',
    type: 'text',
    required: true,
    validationType: 'phone',
  },
  additionalInsuredMaritalStatus: {
    id: 'additional-insured-marital-status',
    questionRef: 'additionalInsuredMaritalStatus',
    title: 'Marital Status',
    type: 'radio',
    required: false,
    format: 'vertical',
    options: [
      { id: 'married', value: 'Married' },
      { id: 'single', value: 'Single' },
      { id: 'civil-union', value: 'Civil Union' },
      { id: 'domestic-partner', value: 'Domestic Partner' },
      { id: 'other', value: 'Other' },
    ],
  },
  additionalInsuredMarriageOther: {
    id: 'additional-insured-marriage-other',
    questionRef: 'additionalInsuredMarriageOther',
    title: 'Other: ',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredMaritalStatus',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'additionalInsuredMaritalStatus',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  additionalInsuredCitizenship: {
    id: 'additional-insured-citizenship',
    questionRef: 'additionalInsuredCitizenship',
    title: 'Citizenship',
    type: 'radio',
    required: false,
    options: [
      { id: 'us', value: 'U.S.' },
      { id: 'green-card', value: 'Green Card Holder' },
      { id: 'visa', value: 'Visa' },
      { id: 'other', value: 'Other' },
    ],
  },
  additionalInsuredGreenCardIssueDate: {
    id: 'additional-insured-green-card-issue-date',
    questionRef: 'additionalInsuredGreenCardIssueDate',
    title: 'Green Card Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  additionalInsuredGreenCardExpirationDate: {
    id: 'additional-insured-green-card-expiration-date',
    questionRef: 'additionalInsuredGreenCardExpirationDate',
    title: 'Green Card Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  additionalInsuredVisaType: {
    id: 'additional-insured-visa-type',
    questionRef: 'additionalInsuredVisaType',
    title: 'Visa Type',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  additionalInsuredVisaIssueDate: {
    id: 'additional-insured-visa-issue-date',
    questionRef: 'additionalInsuredVisaIssueDate',
    title: 'Visa Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  additionalInsuredVisaExpirationDate: {
    id: 'additional-insured-visa-expiration-date',
    questionRef: 'additionalInsuredVisaExpirationDate',
    title: 'Visa Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  additionalInsuredOther: {
    id: 'additional-insured-other',
    questionRef: 'additionalInsuredOther',
    title: 'Other:',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'additionalInsuredCitizenship',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  additionalInsuredUsResidenceMonths: {
    id: 'additional-insured-us-residence-months',
    questionRef: 'additionalInsuredUsResidenceMonths',
    title: 'How long have you lived in the U.S.? (Months)',
    type: 'text',
    required: false,
    validationType: 'numberOnly',
  },
  additionalInsuredUsResidenceYears: {
    id: 'additional-insured-us-residence-years',
    questionRef: 'additionalInsuredUsResidenceYears',
    title: 'How long have you lived in the U.S.? (Years)',
    type: 'text',
    required: false,
    validationType: 'numberOnly',
  },
  additionalInsuredUnderstandEnglish: {
    id: 'additional-insured-understand-english',
    questionRef: 'additionalInsuredUnderstandEnglish',
    title: 'Do you read and understand English?',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredPrimaryLanguage: {
    id: 'additional-insured-primary-language',
    questionRef: 'additionalInsuredPrimaryLanguage',
    title: 'If no, provide primary spoken language',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'additionalInsuredUnderstandEnglish',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'additionalInsuredUnderstandEnglish',
        operator: 'equals',
        value: 'no',
      },
    },
  },
  additionalInsuredRelationship: {
    id: 'additional-insured-relationship',
    questionRef: 'additionalInsuredRelationship',
    title: 'Relationship to Proposed Insured',
    type: 'text',
    required: false,
  },
  additionalInsuredFormerName: {
    id: 'additional-insured-former-name',
    questionRef: 'additionalInsuredFormerName',
    title: 'Former Name',
    type: 'text',
    required: false,
  },
  additionalInsuredDriversLicense: {
    id: 'additional-insured-drivers-license',
    questionRef: 'additionalInsuredDriversLicense',
    title: "Driver's License #/State of Issue",
    type: 'text',
    required: true,
  },
  additionalInsuredOccupation: {
    id: 'additional-insured-occupation',
    questionRef: 'additionalInsuredOccupation',
    title: 'Occupation',
    type: 'text',
    required: true,
  },
  additionalInsuredEmployer: {
    id: 'additional-insured-employer',
    questionRef: 'additionalInsuredEmployer',
    title: 'Employer',
    type: 'text',
    required: true,
  },
  additionalInsuredAnnualIncome: {
    id: 'additional-insured-annual-income',
    questionRef: 'additionalInsuredAnnualIncome',
    title: 'Annual Income',
    type: 'text',
    required: false,
    validationType: 'currency',
  },
  additionalInsuredNetWorth: {
    id: 'additional-insured-net-worth',
    questionRef: 'additionalInsuredNetWorth',
    title: 'Net Worth',
    type: 'text',
    required: false,
    validationType: 'currency',
  },

  /* Section 3 - Policy Owner */
  policyOwnerType: {
    id: 'policy-owner-type',
    questionRef: 'policyOwnerType',
    title: 'Type of Policy Owner',
    type: 'radio',
    required: false,
    options: [
      { id: 'individual', value: 'Individual' },
      { id: 'employer', value: 'Employer' },
      { id: 'trust', value: 'Trust' },
      { id: 'rabbi-trust', value: 'Rabbi Trust' },
      { id: 'other', value: 'Other' },
    ],
  },
  policyOwnerOtherType: {
    id: 'policy-owner-other-type',
    questionRef: 'policyOwnerOtherType',
    title: 'Other: ',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerType',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'policyOwnerType',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  policyOwnerName: {
    id: 'policy-owner-name',
    questionRef: 'policyOwnerName',
    title: 'Name (First, MI, Last)',
    type: 'text',
    required: false,
    composite: {
      questionRefs: ['ownerOtherFirstName', 'ownerOtherLastName'],
      delimiter: ' ',
      allowAppendText: true,
    },
  },
  policyOwnerSsn: {
    id: 'policy-owner-ssn',
    questionRef: 'policyOwnerSsn',
    title: 'SSN/Tax ID #',
    type: 'text',
    required: false,
    validationType: 'ssn',
  },
  policyOwnerDob: {
    id: 'policy-owner-dob',
    questionRef: 'policyOwnerDob',
    title: 'Date of Birth',
    type: 'date',
    required: false,
  },
  policyOwnerSameAddress: {
    id: 'policy-owner-same-address',
    questionRef: 'policyOwnerSameAddress',
    title: '',
    type: 'multiselect',
    required: false,
    options: [{ id: 'yes', value: 'Check box if address is same as Proposed Primary Insured' }],
  },
  policyOwnerAddress: {
    id: 'policy-owner-address',
    questionRef: 'policyOwnerAddress',
    title: 'Address (street/city/state/ZIP)',
    type: 'text',
    validationType: 'address',
    conditional: {
      visible: {
        field: 'policyOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'policyOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  policyOwnerPhone: {
    id: 'policy-owner-phone',
    questionRef: 'policyOwnerPhone',
    title: 'Phone #',
    type: 'text',
    required: false,
    validationType: 'phone',
  },
  policyOwnerCitizenship: {
    id: 'policy-owner-citizenship',
    questionRef: 'policyOwnerCitizenship',
    title: 'Citizenship',
    type: 'radio',
    required: false,
    options: [
      { id: 'us', value: 'U.S.' },
      { id: 'green-card', value: 'Green Card Holder' },
      { id: 'visa', value: 'Visa' },
      { id: 'other', value: 'Other' },
    ],
  },
  policyOwnerGreenCardIssueDate: {
    id: 'policy-owner-green-card-issue-date',
    questionRef: 'policyOwnerGreenCardIssueDate',
    title: 'Green Card Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  policyOwnerGreenCardExpirationDate: {
    id: 'policy-owner-green-card-expiration-date',
    questionRef: 'policyOwnerGreenCardExpirationDate',
    title: 'Green Card Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  policyOwnerVisaType: {
    id: 'policy-owner-visa-type',
    questionRef: 'policyOwnerVisaType',
    title: 'Visa Type',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  policyOwnerVisaIssueDate: {
    id: 'policy-owner-visa-issue-date',
    questionRef: 'policyOwnerVisaIssueDate',
    title: 'Visa Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  policyOwnerVisaExpirationDate: {
    id: 'policy-owner-visa-expiration-date',
    questionRef: 'policyOwnerVisaExpirationDate',
    title: 'Visa Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  policyOwnerOther: {
    id: 'policy-owner-other',
    questionRef: 'policyOwnerOther',
    title: 'Other:',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'policyOwnerCitizenship',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  policyOwnerEmail: {
    id: 'policy-owner-email',
    questionRef: 'policyOwnerEmail',
    title: 'E-mail',
    type: 'text',
    required: false,
    validationType: 'email',
    composite: {
      questionRefs: ['ownerOtherEmail'],
      delimiter: ' ',
      allowAppendText: true,
    },
  },
  policyOwnerRelationship: {
    id: 'policy-owner-relationship',
    questionRef: 'policyOwnerRelationship',
    title: 'Relationship to Proposed Insured',
    type: 'text',
    required: false,
  },
  policyOwnerAnnualIncome: {
    id: 'policy-owner-annual-income',
    questionRef: 'policyOwnerAnnualIncome',
    title: 'Annual Income',
    type: 'text',
    required: false,
    validationType: 'currency',
  },
  policyOwnerNetWorth: {
    id: 'policy-owner-net-worth',
    questionRef: 'policyOwnerNetWorth',
    title: 'Net Worth',
    type: 'text',
    required: false,
    validationType: 'currency',
  },
  trustName: {
    id: 'trust-name',
    questionRef: 'trustName',
    title: 'Exact Name of Trust',
    type: 'text',
    required: true,
  },
  trustTaxId: {
    id: 'trust-tax-id',
    questionRef: 'trustTaxId',
    title: 'Trust Tax ID Number',
    type: 'text',
    required: true,
  },
  trustDate: {
    id: 'trust-date',
    questionRef: 'trustDate',
    title: 'Date of Trust',
    type: 'date',
    required: true,
  },
  currentTrustees: {
    id: 'current-trustees',
    questionRef: 'currentTrustees',
    title: 'Current Trustee(s)',
    type: 'text',
    required: true,
  },

  /* Section 3.5 - Joint Policy Owner */
  jointPolicyOwnerType: {
    id: 'joint-policy-owner-type',
    questionRef: 'jointPolicyOwnerType',
    title: 'Type of Joint Policy Owner',
    type: 'radio',
    required: true,
    options: [
      { id: 'individual', value: 'Individual' },
      { id: 'employer', value: 'Employer' },
      { id: 'other', value: 'Other' },
    ],
  },
  jointPolicyOwnerOtherType: {
    id: 'joint-policy-owner-other-type',
    questionRef: 'jointPolicyOwnerOtherType',
    title: 'Other: ',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerType',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'jointPolicyOwnerType',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  jointPolicyOwnerName: {
    id: 'joint-policy-owner-name',
    questionRef: 'jointPolicyOwnerName',
    title: 'Name (First, MI, Last)',
    type: 'text',
    required: true,
    composite: {
      questionRefs: ['ownerJointOtherFirstName', 'ownerJointOtherLastName'],
      delimiter: ' ',
      allowAppendText: true,
    },
  },
  jointPolicyOwnerSsn: {
    id: 'joint-policy-owner-ssn',
    questionRef: 'jointPolicyOwnerSsn',
    title: 'SSN/Tax ID #',
    type: 'text',
    required: true,
    validationType: 'ssn',
  },
  jointPolicyOwnerDob: {
    id: 'joint-policy-owner-dob',
    questionRef: 'jointPolicyOwnerDob',
    title: 'Date of Birth',
    type: 'date',
    required: true,
  },
  jointPolicyOwnerAddress: {
    id: 'joint-policy-owner-address',
    questionRef: 'jointPolicyOwnerAddress',
    title: 'Address (street/city/state/ZIP)',
    type: 'text',
    required: false,
    validationType: 'address',
    conditional: {
      visible: {
        field: 'jointPolicyOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'jointPolicyOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  jointPolicyOwnerPhone: {
    id: 'joint-policy-owner-phone',
    questionRef: 'jointPolicyOwnerPhone',
    title: 'Phone #',
    type: 'text',
    required: true,
    validationType: 'phone',
  },
  jointPolicyOwnerCitizenship: {
    id: 'joint-policy-owner-citizenship',
    questionRef: 'jointPolicyOwnerCitizenship',
    title: 'Citizenship',
    type: 'radio',
    required: true,
    options: [
      { id: 'us', value: 'U.S.' },
      { id: 'green-card', value: 'Green Card Holder' },
      { id: 'visa', value: 'Visa' },
      { id: 'other', value: 'Other' },
    ],
  },
  jointPolicyOwnerGreenCardIssueDate: {
    id: 'joint-policy-owner-green-card-issue-date',
    questionRef: 'jointPolicyOwnerGreenCardIssueDate',
    title: 'Green Card Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  jointPolicyOwnerGreenCardExpirationDate: {
    id: 'joint-policy-owner-green-card-expiration-date',
    questionRef: 'jointPolicyOwnerGreenCardExpirationDate',
    title: 'Green Card Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
      required: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'green-card',
      },
    },
  },
  jointPolicyOwnerVisaType: {
    id: 'joint-policy-owner-visa-type',
    questionRef: 'jointPolicyOwnerVisaType',
    title: 'Visa Type',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  jointPolicyOwnerVisaIssueDate: {
    id: 'joint-policy-owner-visa-issue-date',
    questionRef: 'jointPolicyOwnerVisaIssueDate',
    title: 'Visa Issue Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  jointPolicyOwnerVisaExpirationDate: {
    id: 'joint-policy-owner-visa-expiration-date',
    questionRef: 'jointPolicyOwnerVisaExpirationDate',
    title: 'Visa Expiration Date',
    type: 'date',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
      required: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'visa',
      },
    },
  },
  jointPolicyOwnerOther: {
    id: 'joint-policy-owner-other',
    questionRef: 'jointPolicyOwnerOther',
    title: 'Other:',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'other',
      },
      required: {
        field: 'jointPolicyOwnerCitizenship',
        operator: 'equals',
        value: 'other',
      },
    },
  },
  jointPolicyOwnerEmail: {
    id: 'joint-policy-owner-email',
    questionRef: 'jointPolicyOwnerEmail',
    title: 'E-mail',
    type: 'text',
    required: true,
    validationType: 'email',
    composite: {
      questionRefs: ['ownerJointOtherEmail'],
      delimiter: ' ',
      allowAppendText: true,
    },
  },
  jointPolicyOwnerRelationship: {
    id: 'joint-policy-owner-relationship',
    questionRef: 'jointPolicyOwnerRelationship',
    title: 'Relationship to Proposed Insured',
    type: 'text',
    required: true,
  },

  /* Section 4 - Contingent Owner */
  contingentOwnerName: {
    id: 'contingent-owner-name',
    questionRef: 'contingentOwnerName',
    title: 'Name (First, MI, Last)',
    type: 'text',
    required: false,
  },
  contingentOwnerSsn: {
    id: 'contingent-owner-ssn',
    questionRef: 'contingentOwnerSsn',
    title: 'SSN / Tax ID #',
    type: 'text',
    required: false,
    validationType: 'ssn',
  },
  contingentOwnerSameAddress: {
    id: 'contingent-owner-same-address',
    questionRef: 'contingentOwnerSameAddress',
    title: '',
    type: 'multiselect',
    required: false,
    options: [{ id: 'yes', value: 'Check box if address is same as Proposed Primary Insured' }],
  },
  contingentOwnerAddress: {
    id: 'contingent-owner-address',
    questionRef: 'contingentOwnerAddress',
    title: 'Address',
    type: 'text',
    conditional: {
      visible: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  contingentOwnerCity: {
    id: 'contingent-owner-city',
    questionRef: 'contingentOwnerCity',
    title: 'City',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  contingentOwnerState: {
    id: 'contingent-owner-state',
    questionRef: 'contingentOwnerState',
    title: 'State',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  contingentOwnerZipCode: {
    id: 'contingent-owner-zip-code',
    questionRef: 'contingentOwnerZipCode',
    title: 'Zip Code',
    type: 'text',
    required: false,
    validationType: 'zipcode',
    conditional: {
      visible: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  contingentOwnerCounty: {
    id: 'contingent-owner-county',
    questionRef: 'contingentOwnerCounty',
    title: 'County',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
      required: {
        field: 'contingentOwnerSameAddress',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },
  contingentOwnerRelationship: {
    id: 'contingent-owner-relationship',
    questionRef: 'contingentOwnerRelationship',
    title: 'Relationship to Insured',
    type: 'text',
    required: false,
  },
  contingentOwnerDob: {
    id: 'contingent-owner-dob',
    questionRef: 'contingentOwnerDob',
    title: 'Date of Birth',
    type: 'date',
    required: false,
  },

  /* Section 5 - Payor */
  payorName: {
    id: 'payor-name',
    questionRef: 'payorName',
    title: 'Payor Name (First, MI, Last)',
    type: 'text',
    required: true,
  },
  payorSsn: {
    id: 'payor-ssn',
    questionRef: 'payorSsn',
    title: 'SSN/Tax ID #',
    type: 'text',
    required: true,
    validationType: 'ssn',
  },
  payorRelationship: {
    id: 'payor-relationship',
    questionRef: 'payorRelationship',
    title: 'Relationship to Proposed Insured',
    type: 'text',
    required: true,
  },
  payorAddress: {
    id: 'payor-address',
    questionRef: 'payorAddress',
    title: 'Payor Address (street/city/state/ZIP)',
    type: 'text',
    required: true,
    validationType: 'address',
  },
  payorEmail: {
    id: 'payor-email',
    questionRef: 'payorEmail',
    title: 'Payor E-mail',
    type: 'text',
    required: true,
    validationType: 'email',
  },
  payorPhone: {
    id: 'payor-phone',
    questionRef: 'payorPhone',
    title: 'Payor Phone #',
    type: 'text',
    required: true,
    validationType: 'phone',
  },

  /* Section 6 - Beneficiary Designations */
  primaryBeneficiarySameAsOwner: {
    id: 'primary-beneficiary-same-as-owner',
    questionRef: 'primaryBeneficiarySameAsOwner',
    title: '',
    type: 'multiselect',
    required: false,
    options: [
      { id: 'yes', value: 'Check box if the Primary Beneficiary and the Owner are the same.' },
    ],
  },
  beneficiaryDesignations: {
    id: 'beneficiary-designations',
    questionRef: 'beneficiaryDesignations',
    title: 'Beneficiary Designations',
    type: 'table',
    required: true,
    minRows: 1,
    maxRows: 3,
    gridColumns: 3,
    columns: [
      {
        id: 'designation-percent',
        title: '%',
        type: 'text',
        required: true,
      },
      {
        id: 'designation-type',
        title: 'Designation',
        type: 'radio',
        required: true,
        options: [
          { id: 'primary', value: 'Primary' },
          { id: 'contingent', value: 'Contingent' },
        ],
      },
      {
        id: 'beneficiary-name',
        title: 'Beneficiary Name',
        type: 'text',
        required: true,
        placeholder: 'Enter beneficiary name',
      },
      {
        id: 'date-of-birth',
        title: 'Date of Birth',
        type: 'text',
        required: true,
        placeholder: 'mm/dd/yyyy',
      },
      {
        id: 'relationship',
        title: 'Relationship to Insured',
        type: 'text',
        required: true,
        placeholder: 'Enter relationship',
      },
      {
        id: 'ssn-tax-id',
        title: 'SSN/Tax ID #',
        type: 'text',
        required: true,
        placeholder: 'Enter SSN/Tax ID',
      },
      {
        id: 'address-phone',
        title: 'Address & Phone #',
        type: 'text',
        required: true,
        placeholder: 'Enter address and phone',
      },
    ],
    conditional: {
      required: {
        field: 'primaryBeneficiarySameAsOwner',
        operator: 'notEquals',
        value: 'yes',
      },
    },
  },

  /* Section 7 - Premium and Billing Information */
  premiumOption: {
    id: 'premium-option',
    questionRef: 'premiumOption',
    title: 'Premium Payment Option',
    type: 'radio',
    required: true,
    format: 'vertical',
    options: [
      { id: 'option1', value: 'Option 1 - Single Premium' },
      { id: 'option2', value: 'Option 2 - Recurring Premium' },
      { id: 'option3', value: 'Option 3 - Lump Sum + Recurring Premium' },
    ],
  },
  singlePremiumAmount: {
    id: 'single-premium-amount',
    questionRef: 'singlePremiumAmount',
    title: 'Single Premium Amount',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option1',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option1',
      },
    },
  },
  singlePremiumPayment: {
    id: 'single-premium-payment',
    questionRef: 'singlePremiumPayment',
    title: 'Funded by payment of',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option1',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option1',
      },
    },
  },
  singlePremium1035Exchange: {
    id: 'single-premium-1035-exchange',
    questionRef: 'singlePremium1035Exchange',
    title: 'And/or 1035 exchange of',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option1',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option1',
      },
    },
  },
  levelPremiumAmount: {
    id: 'level-premium-amount',
    questionRef: 'levelPremiumAmount',
    title: 'Level Premium Amount',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option2',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option2',
      },
    },
  },
  op2PaymentFrequency: {
    id: 'op2-payment-frequency',
    questionRef: 'op2PaymentFrequency',
    title: 'Option 2 Reccuring Payment Frequency',
    type: 'radio',
    required: false,
    options: [
      { id: 'monthly', value: 'Monthly' },
      { id: 'annually', value: 'Annually' },
    ],
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option2',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option2',
      },
    },
  },
  op2PaymentDuration: {
    id: 'op2-payment-duration',
    questionRef: 'op2PaymentDuration',
    title: 'Option 2 Reccuring Payment Duration',
    type: 'radio',
    required: false,
    format: 'vertical',
    options: [
      { id: '5-years', value: '5 Years' },
      { id: '10-years', value: '10 Years' },
      {
        id: '20-years',
        value: '20 Years',
        conditional: {
          visible: {
            field: 'fundingPolicyType',
            operator: 'equals' as const,
            value: FundingPolicyType.jointCareMatters,
          },
        }
      },
      {
        id: 'to-age-65',
        value: 'To Attained Age 65',
        conditional: {
          visible: {
            field: 'fundingPolicyType',
            operator: 'notEquals' as const,
            value: FundingPolicyType.jointCareMatters,
          },
        }
      },
      { id: 'to-age-100', value: 'To Attained Age 100' },
    ],
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option2',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option2',
      },
    },
  },
  op3PaymentFrequency: {
    id: 'op3-payment-frequency',
    questionRef: 'op3PaymentFrequency',
    title: 'Option 3 Reccuring Payment Frequency',
    type: 'radio',
    required: false,
    options: [
      { id: 'monthly', value: 'Monthly' },
      { id: 'annually', value: 'Annually' },
    ],
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
    },
  },
  op3PaymentDuration: {
    id: 'op3-payment-duration',
    questionRef: 'op3PaymentDuration',
    title: 'Option 3 Reccuring Payment Duration',
    type: 'radio',
    required: false,
    options: [
      { id: '5-years', value: '5 Years' },
      { id: '10-years', value: '10 Years' },
      {
        id: '20-years',
        value: '20 Years',
        conditional: {
          visible: {
            field: 'fundingPolicyType',
            operator: 'equals' as const,
            value: FundingPolicyType.jointCareMatters,
          },
        },
      },
      {
        id: 'to-age-65',
        value: 'To Attained Age 65',
        conditional: {
          visible: {
            field: 'fundingPolicyType',
            operator: 'notEquals' as const,
            value: FundingPolicyType.jointCareMatters,
          },
        },
      },
      { id: 'to-age-100', value: 'To Attained Age 100' },
    ],
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
    },
  },
  lumpSumAmount: {
    id: 'lump-sum-amount',
    questionRef: 'lumpSumAmount',
    title: 'Lump Sum Amount',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
    },
  },
  lumpSumPayment: {
    id: 'lump-sum-payment',
    questionRef: 'lumpSumPayment',
    title: 'Funded by payment of',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
    },
  },
  lumpSum1035Exchange: {
    id: 'lump-sum-1035-exchange',
    questionRef: 'lumpSum1035Exchange',
    title: 'And/or 1035 exchange of',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
    },
  },
  combinedLevelPremiumAmount: {
    id: 'combined-level-premium-amount',
    questionRef: 'combinedLevelPremiumAmount',
    title: 'Combined with Level Premium Amount of',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
      required: {
        field: 'premiumOption',
        operator: 'equals',
        value: 'option3',
      },
    },
  },
  levelPremiumStartMonth: {
    id: 'level-premium-start-month',
    questionRef: 'levelPremiumStartMonth',
    title:
      'For monthly frequency, in month (If no value given, month 1 will apply. Cannot exceed month 6.)',
    type: 'number',
    required: false,
    conditional: {
      visible: {
        field: 'op3PaymentFrequency',
        operator: 'equals',
        value: 'monthly',
      },
      required: {
        field: 'op3PaymentFrequency',
        operator: 'equals',
        value: 'monthly',
      },
    },
  },
  levelPremiumStartYear: {
    id: 'level-premium-start-year',
    questionRef: 'levelPremiumStartYear',
    title:
      'For annual frequency, in year (If no value given, year 1 will apply. Cannot exceed year 2.)',
    type: 'number',
    required: false,
    conditional: {
      visible: {
        field: 'op3PaymentFrequency',
        operator: 'equals',
        value: 'annually',
      },
      required: {
        field: 'op3PaymentFrequency',
        operator: 'equals',
        value: 'annually',
      },
    },
  },

  /* Section 8 - Advance Payment */
  advancePaymentMethod: {
    id: 'advance-payment-method',
    questionRef: 'advancePaymentMethod',
    title: 'Advance Payment Method',
    type: 'radio',
    required: false,
    options: [
      { id: 'check-wire', value: 'Check/Wire premium with application' },
      { id: 'electronic-debit', value: 'Electronic Debit (ACH) for initial premium payment' },
    ],
  },
  electronicDebitAmount: {
    id: 'electronic-debit-amount',
    questionRef: 'electronicDebitAmount',
    title: 'Electronic Debit Amount',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'advancePaymentMethod',
        operator: 'equals',
        value: 'electronic-debit',
      },
      required: {
        field: 'advancePaymentMethod',
        operator: 'equals',
        value: 'electronic-debit',
      },
    },
  },

  /* Section 9 - Future Billing Options */
  directBill: {
    id: 'direct-bill',
    questionRef: 'directBill',
    title: 'Direct Bill',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  directBillAmount: {
    id: 'direct-bill-amount',
    questionRef: 'directBillAmount',
    title: 'Direct Bill Amount (Annually)',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'directBill',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'directBill',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  listBill: {
    id: 'list-bill',
    questionRef: 'listBill',
    title: 'List Bill',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  listBillAmount: {
    id: 'list-bill-amount',
    questionRef: 'listBillAmount',
    title: 'List Bill Amount',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'listBill',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'listBill',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  fundedByAnnuity: {
    id: 'funded-by-annuity',
    questionRef: 'fundedByAnnuity',
    title: 'Funded by a Nationwide Annuity Contract',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  fundedByAnnuityAmount: {
    id: 'funded-by-annuity-amount',
    questionRef: 'fundedByAnnuityAmount',
    title: 'Annuity Funding Amount (Annually)',
    type: 'text',
    required: false,
    validationType: 'currency',
    conditional: {
      visible: {
        field: 'fundedByAnnuity',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'fundedByAnnuity',
        operator: 'equals',
        value: 'yes',
      },
    },
  },
  recurringAchDebit: {
    id: 'recurring-ach-debit',
    questionRef: 'recurringAchDebit',
    title: 'Recurring ACH debit',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  /* Section 10 - CareMatters II Plan Information */
  caremattersIIBaseAmount: {
    id: 'carematters-ii-base-amount',
    questionRef: 'caremattersIIBaseAmount',
    title: 'Nationwide CareMatters® II Base Specified Amount',
    type: 'text',
    required: true,
    validationType: 'currency',
  },
  ltcSpecifiedBenefitPeriod: {
    id: 'ltc-specified-benefit-period',
    questionRef: 'ltcSpecifiedBenefitPeriod',
    title: 'Long-Term Care (LTC) Specified Benefit Period',
    type: 'radio',
    required: true,
    options: [
      { id: '2-years', value: '2 Years' },
      { id: '3-years', value: '3 Years' },
      { id: '4-years', value: '4 Years' },
      { id: '5-years', value: '5 Years' },
      { id: '6-years', value: '6 Years' },
      { id: '7-years', value: '7 Years' },
    ],
  },
  ltcInflationProtection: {
    id: 'ltc-inflation-protection',
    questionRef: 'ltcInflationProtection',
    title: 'Long-Term Care Inflation Protection Option',
    type: 'radio',
    required: true,
    options: [
      { id: '5-compound', value: '5% Compound Interest Inflation Protection' },
      { id: '3-compound', value: '3% Compound Interest Inflation Protection' },
      { id: '3-simple', value: '3% Simple Interest Inflation Protection' },
      { id: 'indexed-rate', value: 'Long-Term Care Indexed Rate Inflation Protection Rider' },
      // NOTE: If this id is ever changed we'd need to update it in evaluateConditionalRequirement
      { id: 'reject-all', value: ' I hereby REJECT all inflation benefit options' },
    ],
    format: 'vertical',
    minRows: 1,
    maxRows: 5
  },
  refundOfPremiumOption: {
    id: 'refund-of-premium-option',
    questionRef: 'refundOfPremiumOption',
    title: 'Refund of Premium Option',
    type: 'radio',
    required: true,
    options: [
      { id: 'vested', value: 'Vested' },
      { id: 'one-time-step-up', value: 'One Time Step-Up' },
      {
        id: 'minimum-refund-maximum-ltc',
        value: 'Minimum Refund of Premium with Maximum Long-Term Care Benefit',
      },
    ],
  },

  /* Section 11 - CareMatters Together Plan Information */
  caremattersTogetherBaseAmount: {
    id: 'carematters-together-base-amount',
    questionRef: 'caremattersTogetherBaseAmount',
    title: 'Nationwide CareMatters TogetherSM Base Specified Amount',
    type: 'text',
    required: true,
    validationType: 'currency',
  },
  maxMonthlyLtcPayments: {
    id: 'max-monthly-ltc-payments',
    questionRef: 'maxMonthlyLtcPayments',
    title: 'Maximum Number of Full Monthly LTC Benefit Payments',
    type: 'radio',
    required: true,
    options: [
      { id: '48-payments', value: '48 Full Monthly LTC Benefit Payments' },
      { id: '72-payments', value: '72 Full Monthly LTC Benefit Payments' },
      { id: '96-payments', value: '96 Full Monthly LTC Benefit Payments' },
    ],
  },
  togetherInflationProtection: {
    id: 'together-inflation-protection',
    questionRef: 'togetherInflationProtection',
    title: 'Long-Term Care Inflation Protection Option',
    type: 'radio',
    required: true,
    format: 'vertical',
    options: [
      { id: '5-compound', value: '5% Compound Inflation Protection' },
      { id: '3-compound', value: '3% Compound Inflation Protection' },
      { id: '3-compound-20', value: '3% Compound for 20 Years Inflation Protection' },
      { id: 'reject-all', value: 'I hereby REJECT all inflation benefit options' },
    ],
  },

  /* Section 12 - Protection Against Unintended Lapse */
  thirdPartyDesignee: {
    id: 'third-party-designee',
    questionRef: 'thirdPartyDesignee',
    title: 'Third Party Designee Election',
    type: 'radio',
    required: true,
    options: [
      { id: 'elect-not', value: 'I elect NOT to name a Third Party Designee' },
      { id: 'elect', value: 'I elect to name a Third Party Designee' },
    ],
  },
  thirdPartyDesigneeName: {
    id: 'third-party-designee-name',
    questionRef: 'thirdPartyDesigneeName',
    title: 'Full Name of Third Party Designee (First, MI, Last)',
    type: 'text',
    required: true,
    conditional: {
      visible: {
        field: 'thirdPartyDesignee',
        operator: 'equals',
        value: 'elect',
      },
      required: {
        field: 'thirdPartyDesignee',
        operator: 'equals',
        value: 'elect',
      },
    },
  },
  thirdPartyDesigneeAddress: {
    id: 'third-party-designee-address',
    questionRef: 'thirdPartyDesigneeAddress',
    title: 'Address (street/city/state/ZIP)',
    type: 'text',
    required: true,
    validationType: 'address',
    conditional: {
      visible: {
        field: 'thirdPartyDesignee',
        operator: 'equals',
        value: 'elect',
      },
      required: {
        field: 'thirdPartyDesignee',
        operator: 'equals',
        value: 'elect',
      },
    },
  },

  /* Section 13 - Taxpayer Certification */
  backupWithholding: {
    id: 'backup-withholding',
    questionRef: 'backupWithholding',
    title: '',
    type: 'multiselect',
    required: false,
    options: [
      {
        id: 'yes',
        value:
          'Check this box if you have been notified by the IRS that you are currently subject to backup witholding because of failure to report interest or dividends on your tax return.',
      },
    ],
  },

  /* Section 14 - Electronic Delivery Election */
  electronicDelivery: {
    id: 'electronic-delivery',
    questionRef: 'electronicDelivery',
    title: 'Electronic Delivery Election',
    type: 'radio',
    required: true,
    options: [
      { id: 'elect', value: 'I elect to receive all documents electronically' },
      { id: 'do-not-elect', value: 'I do not elect to receive documents electronically' },
    ],
  },

  /* Section 15 - Insurance Information - Primary Insured */
  primaryInsuredOtherInsurance: {
    id: 'primary-insured-other-insurance',
    questionRef: 'primaryInsuredOtherInsurance',
    title:
      'Do you have any other Life Insurance or Annuities, including those with Long-Term Care coverage currently in force?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredSoldPolicy: {
    id: 'primary-insured-sold-policy',
    questionRef: 'primaryInsuredSoldPolicy',
    title: 'Have you ever sold any Life Insurance policy to a third party?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredRecentApplications: {
    id: 'primary-insured-recent-applications',
    questionRef: 'primaryInsuredRecentApplications',
    title:
      'Are you now applying, or have you applied in the past 12 months, for Life Insurance or Annuities, including those with Long-Term Care coverage, with any other Company?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredReplacement: {
    id: 'primary-insured-replacement',
    questionRef: 'primaryInsuredReplacement',
    title:
      'Will any Life Insurance or Annuities, including those with Long-Term Care coverage, for this or any other Company be replaced, discontinued, reduced or changed if insurance now applied for is issued?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredPastInsurance: {
    id: 'primary-insured-past-insurance',
    questionRef: 'primaryInsuredPastInsurance',
    title:
      'Have you had Life Insurance or Annuities, including those with Long-Term Care coverage, in the past 5 years that are no longer in force?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredOtherLtc: {
    id: 'primary-insured-other-ltc',
    questionRef: 'primaryInsuredOtherLtc',
    title:
      'Do you have any other Long-Term Care Insurance Policy or certificate (including a health care service contract or health maintenance organization contract), either currently in force or pending?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredTerminatedLtc: {
    id: 'primary-insured-terminated-ltc',
    questionRef: 'primaryInsuredTerminatedLtc',
    title:
      'Did you have another Long-Term Care Insurance Policy or certificate in force during the past 12 months that has terminated or lapsed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredMedicaid: {
    id: 'primary-insured-medicaid',
    questionRef: 'primaryInsuredMedicaid',
    title: 'Are you covered by Medicaid (Medical Assistance)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredIntendToStop: {
    id: 'primary-insured-intend-to-stop',
    questionRef: 'primaryInsuredIntendToStop',
    title:
      'Do you intend to stop premium payments, replace, surrender, forfeit, assign to the Insurer, or take a cash withdrawal or loan from any Life Insurance Policy or Annuity contract to pay premiums on the applied for Policy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredReplaceMedical: {
    id: 'primary-insured-replace-medical',
    questionRef: 'primaryInsuredReplaceMedical',
    title:
      'Do you intend to replace any of your medical or health insurance coverage, including any of your Long-Term Care coverage, with this applied for Policy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  /* Section 15 - Insurance Information - Additional Insured */
  additionalInsuredOtherInsurance: {
    id: 'additional-insured-other-insurance',
    questionRef: 'additionalInsuredOtherInsurance',
    title:
      'Do you have any other Life Insurance or Annuities, including those with Long-Term Care coverage currently in force?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredSoldPolicy: {
    id: 'additional-insured-sold-policy',
    questionRef: 'additionalInsuredSoldPolicy',
    title: 'Have you ever sold any Life Insurance policy to a third party?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredRecentApplications: {
    id: 'additional-insured-recent-applications',
    questionRef: 'additionalInsuredRecentApplications',
    title:
      'Are you now applying, or have you applied in the past 12 months, for Life Insurance or Annuities, including those with Long-Term Care coverage, with any other Company?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredReplacement: {
    id: 'additional-insured-replacement',
    questionRef: 'additionalInsuredReplacement',
    title:
      'Will any Life Insurance or Annuities, including those with Long-Term Care coverage, for this or any other Company be replaced, discontinued, reduced or changed if insurance now applied for is issued?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredPastInsurance: {
    id: 'additional-insured-past-insurance',
    questionRef: 'additionalInsuredPastInsurance',
    title:
      'Have you had Life Insurance or Annuities, including those with Long-Term Care coverage, in the past 5 years that are no longer in force?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredOtherLtc: {
    id: 'additional-insured-other-ltc',
    questionRef: 'additionalInsuredOtherLtc',
    title:
      'Do you have any other Long-Term Care Insurance Policy or certificate (including a health care service contract or health maintenance organization contract), either currently in force or pending?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredTerminatedLtc: {
    id: 'additional-insured-terminated-ltc',
    questionRef: 'additionalInsuredTerminatedLtc',
    title:
      'Did you have another Long-Term Care Insurance Policy or certificate in force during the past 12 months that has terminated or lapsed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredMedicaid: {
    id: 'additional-insured-medicaid',
    questionRef: 'additionalInsuredMedicaid',
    title: 'Are you covered by Medicaid (Medical Assistance)?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredIntendToStop: {
    id: 'additional-insured-intend-to-stop',
    questionRef: 'additionalInsuredIntendToStop',
    title:
      'Do you intend to stop premium payments, replace, surrender, forfeit, assign to the Insurer, or take a cash withdrawal or loan from any Life Insurance Policy or Annuity contract to pay premiums on the applied for Policy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredReplaceMedical: {
    id: 'additional-insured-replace-medical',
    questionRef: 'additionalInsuredReplaceMedical',
    title:
      'Do you intend to replace any of your medical or health insurance coverage, including any of your Long-Term Care coverage, with this applied for Policy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  /* Section 15 - Insurance Information - Tables */
  insuranceCoverageDetails: {
    id: 'insurance-coverage-details',
    questionRef: 'insuranceCoverageDetails',
    title: 'Insurance Coverage Details',
    type: 'table',
    minRows: 0,
    maxRows: 3,
    conditional: {
      visible: {
        operator: 'or',
        conditions: [
          // Primary Insured conditions
          { field: 'primaryInsuredOtherInsurance', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredSoldPolicy', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredRecentApplications', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredReplacement', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredPastInsurance', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredOtherLtc', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredTerminatedLtc', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredIntendToStop', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredReplaceMedical', operator: 'equals', value: 'yes' },
          // Additional Insured conditions
          { field: 'additionalInsuredOtherInsurance', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredSoldPolicy', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredRecentApplications', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredReplacement', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredPastInsurance', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredOtherLtc', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredTerminatedLtc', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredIntendToStop', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredReplaceMedical', operator: 'equals', value: 'yes' },
        ],
      },
    },
    columns: [
      {
        id: 'coverage-type',
        title: 'Coverage Type',
        type: 'radio',
        required: false,
        options: [
          { id: 'life', value: 'Life' },
          { id: 'life-ltc', value: 'Life W/LTC' },
          { id: 'annuity', value: 'Annuity' },
          { id: 'annuity-ltc', value: 'Annuity W/LTC' },
          { id: 'ltc', value: 'LTC' },
          { id: 'health', value: 'Health' },
        ],
      },
      {
        id: 'company',
        title: 'Company',
        type: 'text',
        required: false,
        placeholder: 'Enter company name',
      },
      {
        id: 'policy-number',
        title: 'Policy Number',
        type: 'text',
        required: false,
        placeholder: 'Enter policy number',
      },
      {
        id: 'amount',
        title: 'Amount',
        type: 'text',
        required: false,
        placeholder: 'Enter amount',
      },
      {
        id: 'year-issued',
        title: 'Year Issued',
        type: 'text',
        required: false,
        placeholder: 'YYYY',
      },
      {
        id: 'to-be-replaced',
        title: 'To Be Replaced',
        type: 'radio',
        required: false,
        options: [
          { id: 'yes', value: 'Yes' },
          { id: 'no', value: 'No' },
        ],
      },
      {
        id: '1035-exchange',
        title: '1035',
        type: 'text',
        required: false,
      },
      {
        id: 'lapse-termination-date',
        title: 'Lapse/Termination Date',
        type: 'text',
        required: false,
        placeholder: 'mm/dd/yyyy',
      },
    ],
    format: 'vertical'
  },

  /* Section 16 - Financial Information */
  primaryInsuredEverSold: {
    id: 'primary-insured-ever-sold',
    questionRef: 'primaryInsuredEverSold',
    title: 'Primary Insured',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredPremiumFinanced: {
    id: 'primary-insured-premium-financed',
    questionRef: 'primaryInsuredPremiumFinanced',
    title: 'Primary Insured',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredEverSold: {
    id: 'additional-insured-ever-sold',
    questionRef: 'additionalInsuredEverSold',
    title: 'Additional Insured',
    type: 'radio',
    required: true,
    conditional: {
      visible: {
        field: 'fundingPolicyType',
        operator: 'equals' as const,
        value: FundingPolicyType.jointCareMatters,
      },
    },
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredPremiumFinanced: {
    id: 'additional-insured-premium-financed',
    questionRef: 'additionalInsuredPremiumFinanced',
    title: 'Additional Insured',
    type: 'radio',
    required: true,
    conditional: {
      visible: {
        field: 'fundingPolicyType',
        operator: 'equals' as const,
        value: FundingPolicyType.jointCareMatters,
      },
    },
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  policyOwnerEverSold: {
    id: 'policy-owner-ever-sold',
    questionRef: 'policyOwnerEverSold',
    title: 'Policy Owner',
    type: 'radio',
    required: true,
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'notIn' as const,
        value: ['owner_client', 'owner_joint'],
      },
    },
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  policyOwnerPremiumFinanced: {
    id: 'policy-owner-premium-financed',
    questionRef: 'policyOwnerPremiumFinanced',
    title: 'Policy Owner',
    type: 'radio',
    required: true,
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'notIn' as const,
        value: ['owner_client', 'owner_joint'],
      },
    },
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  /* Section 16 - Financial Information - Table */
  financialInformationDetails: {
    id: 'financial-information-details',
    questionRef: 'financialInformationDetails',
    title: 'Financial Information Details',
    type: 'table',
    minRows: 0,
    maxRows: 3,
    conditional: {
      visible: {
        operator: 'or',
        conditions: [
          { field: 'primaryInsuredEverSold', operator: 'equals', value: 'yes' },
          { field: 'primaryInsuredPremiumFinanced', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredEverSold', operator: 'equals', value: 'yes' },
          { field: 'additionalInsuredPremiumFinanced', operator: 'equals', value: 'yes' },
          { field: 'policyOwnerEverSold', operator: 'equals', value: 'yes' },
          { field: 'policyOwnerPremiumFinanced', operator: 'equals', value: 'yes' },
        ],
      },
    },
    columns: [
      {
        id: 'question-number',
        title: 'Question Number',
        type: 'text',
        required: false,
        placeholder: 'Enter question #',
      },
      {
        id: 'person',
        title: 'Person',
        type: 'text',
        required: false,
        placeholder: 'Enter person',
      },
      {
        id: 'date',
        title: 'Date',
        type: 'text',
        required: false,
        placeholder: 'mm/dd/yyyy',
      },
      {
        id: 'details',
        title: 'Details',
        type: 'text',
        required: false,
        placeholder: 'Enter details',
      },
    ],
  },

  /* Section 17 - Special Instructions */
  specialInstructions: {
    id: 'special-instructions',
    questionRef: 'specialInstructions',
    title: 'Special Instructions',
    type: 'textarea',
    required: false,
    composite: {
      questionRefs: [
        'jointPolicyOwnerType',
        'jointPolicyOwnerOtherType',
        'jointPolicyOwnerName',
        'jointPolicyOwnerSsn',
        'jointPolicyOwnerDob',
        'jointPolicyOwnerAddress',
        'jointPolicyOwnerPhone',
        'jointPolicyOwnerCitizenship',
        'jointPolicyOwnerGreenCardIssueDate',
        'jointPolicyOwnerGreenCardExpirationDate',
        'jointPolicyOwnerVisaType',
        'jointPolicyOwnerVisaIssueDate',
        'jointPolicyOwnerVisaExpirationDate',
        'jointPolicyOwnerOther',
        'jointPolicyOwnerEmail',
        'jointPolicyOwnerRelationship',
      ],
      delimiter: ', ',
      includeMetadata: true,
      allowAppendText: true,
      compositeFieldRef: 'specialInstructionsComposite',
      compositeTitle:
        'To edit the Joint Policy Owner information please navigate back to the Joint Policy Owner section',
    },
  },

  /* Section 22 - Financial Professional's Certification */
  insuranceWillReplace: {
    id: 'insurance-will-replace',
    questionRef: 'insuranceWillReplace',
    title:
      'To the best of my knowledge, the insurance applied for will or will not replace any Life Insurance, Annuities, and/or Long-Term Care Insurance',
    type: 'radio',
    required: true,
    options: [
      { id: 'will', value: 'Will' },
      { id: 'will-not', value: 'Will Not' },
    ],
  },
  financialProfessionalNameCert: {
    id: 'financial-professional-name-cert',
    questionRef: 'financialProfessionalNameCert',
    title: "Financial Professional's Name",
    type: 'text',
    required: true,
  },
  firm: {
    id: 'firm',
    questionRef: 'firm',
    title: 'Firm',
    type: 'text',
    required: true,
  },
  financialProfessionalPhone: {
    id: 'financial-professional-phone',
    questionRef: 'financialProfessionalPhone',
    title: "Financial Professional's Phone Number",
    type: 'text',
    required: true,
    validationType: 'phone',
  },
  nationwideNumber: {
    id: 'nationwide-number',
    questionRef: 'nationwideNumber',
    title: 'Nationwide #',
    type: 'text',
    required: false,
  },
  financialProfessionalEmailCert: {
    id: 'financial-professional-email-cert',
    questionRef: 'financialProfessionalEmailCert',
    title: 'E-mail Address',
    type: 'text',
    required: true,
    validationType: 'email',
  },

  /* Section 23 - Receipt of Form Acknowledgment */
  receiptOfForms: {
    id: 'receipt-of-forms',
    questionRef: 'receiptOfForms',
    title: 'Please check forms that have been delivered and received:',
    type: 'multiselect',
    required: false,
    options: [
      { id: 'ooc', value: 'Outline of Coverage' },
      { id: 'things-ltc', value: 'Things You Should Know Before You Buy Long-Term Care Insurance' },
      { id: 'ltc-worksheet', value: 'LTC Insurance Personal Worksheet' },
      { id: 'shoppers-guide', value: "A Shopper's Guide to Long-Term Care" },
    ],
  },

  /* Temporary Insurance Agreement Health Questions */
  tempInsurancePayment: {
    id: 'temp-insurance-payment',
    questionRef: 'tempInsurancePayment',
    title: 'Advance payment is being made in the amount of',
    type: 'text',
    required: false,
    validationType: 'currency',
  },
  tempInsuranceBaseAmount: {
    id: 'temp-insurance-base-amount',
    questionRef: 'tempInsuranceBaseAmount',
    title: 'For the Base Specified Amount on the application of (or $500,000, whichever is less)',
    type: 'text',
    required: false,
    validationType: 'currency',
  },
  primaryInsuredHealthQ1: {
    id: 'primary-insured-health-q1',
    questionRef: 'primaryInsuredHealthQ1',
    title:
      "Been treated or diagnosed by a member of the medical profession as having Alzheimer's, cognitive disorder or Dementia, AIDS (Acquired Immune Deficiency Syndrome), any AIDS-related disorder or positive HIV (Human Immunodeficiency Virus) test result?",
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  primaryInsuredHealthQ2: {
    id: 'primary-insured-health-q2',
    questionRef: 'primaryInsuredHealthQ2',
    title:
      'Been treated or diagnosed by a member of the medical profession as having diabetes, stroke, cancer, heart disease, alcoholism, drug abuse, or kidney disease?',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredHealthQ1: {
    id: 'additional-insured-health-q1',
    questionRef: 'additionalInsuredHealthQ1',
    title:
      "Been treated or diagnosed by a member of the medical profession as having Alzheimer's, cognitive disorder or Dementia, AIDS (Acquired Immune Deficiency Syndrome), any AIDS-related disorder or positive HIV (Human Immunodeficiency Virus) test result?",
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  additionalInsuredHealthQ2: {
    id: 'additional-insured-health-q2',
    questionRef: 'additionalInsuredHealthQ2',
    title:
      'Been treated or diagnosed by a member of the medical profession as having diabetes, stroke, cancer, heart disease, alcoholism, drug abuse, or kidney disease?',
    type: 'radio',
    required: false,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
};
